<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.64637 3.14645C9.84163 2.95118 10.1581 2.95118 10.3534 3.14645C10.5487 3.34171 10.5487 3.65822 10.3534 3.85348L5.03016 9.17672C4.75557 9.45128 4.32131 9.46823 4.02674 9.22799L3.96961 9.17672L1.64637 6.85348L1.61219 6.81539C1.45201 6.61901 1.46331 6.3295 1.64637 6.14645C1.82943 5.96339 2.11893 5.95209 2.31531 6.11227L2.3534 6.14645L4.49988 8.29293L9.64637 3.14645Z"
      fill="currentColor"
    />
  </svg>
</template>
